<template>
    <div class="app has-header">
        <div class="header main">



            <div class="align-middle">
                <headerbuttonstack :state="headerButtons"/>
            </div>


        </div>
        <div class ="tablecontainer scrollbar-container">
            <datatable :state="allowedContractsTableState" v-if="!loading"/>
        </div>


        <div v-if="loading" class="loading-md bg">
            <i class="fas fa-spinner"></i>

        </div>
    </div>

</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
    name: 'allowedcontracts',
    data () {
        return {
            allowedContractMap:{},
            loading: false,
        }
    },
    created: function () {
        if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
            this.refresh();
        }
    },
    computed: {
        ...mapGetters(['storeId', 'collectiveContractMap', 'storeSettings', 'uiDataMap']),
        countryMap() {
            let map = {};
            this.uiDataMap.countries.forEach(item => map[item.id] = item.label_de);
            return map;
        },
        allowedContractsTableState(){
            let view = this;
            let state = {};

            state = this.$helpers.GetDataTableStateFromObject({name: '', country: '', overtime: '',weekTimeRegular: 40*60, weekWorkDaysRegular: 5, monthTimeRegular: 0, workTimeFactor: 43250000, additionalMonthWorkTime: 0, active: true}, Object.values(view.allowedContractMap).sort((a,b) => {
                let aName = view.collectiveContractMap[a.collectiveContractId] ? view.collectiveContractMap[a.collectiveContractId].name : "";
                let bName = view.collectiveContractMap[b.collectiveContractId] ? view.collectiveContractMap[b.collectiveContractId].name : "";
                let res = aName.localeCompare(bName);
                if(res == 0){
                    res = b.weekTimeRegular - a.weekTimeRegular;
                    if(res == 0){
                        res = b.weekWorkDaysRegular - a.weekWorkDaysRegular;
                    }

                }
                return res;
            }));
            state.headerMap['name'].sort = true;
            state.headerMap['name'].align = 'center';
            state.headerMap['name'].label = this.storeSettings.country == 1 ? this.$t('pages.employeeContract.collectiveContract') : this.$t('pages.employeeContract.contractModel');
            state.headerMap['name'].DisplayLabel = (i) => {return view.collectiveContractMap[i.collectiveContractId] ? view.collectiveContractMap[i.collectiveContractId].name : ""};
            state.headerMap['country'].sort = true;
            state.headerMap['country'].align = 'center';
            state.headerMap['country'].label = this.$t('pages.employeeCoreData.country');
            state.headerMap['country'].DisplayLabel = (i) => {return view.collectiveContractMap[i.collectiveContractId] ? view.countryMap[view.collectiveContractMap[i.collectiveContractId].country] : ""};
            state.headerMap['weekTimeRegular'].sort = true;
            state.headerMap['weekTimeRegular'].align = 'center';
            state.headerMap['weekTimeRegular'].label = this.$t('pages.employeeContract.weekTimeRegular');
            state.headerMap['weekTimeRegular'].DisplayLabel = (i) => {return (i.weekTimeRegular/60).toFixed(2)};
            state.headerMap['weekWorkDaysRegular'].sort = true;
            state.headerMap['weekWorkDaysRegular'].align = 'center';
            state.headerMap['weekWorkDaysRegular'].label = this.$t('store.allowedContracts.workDays');
            state.headerMap['weekWorkDaysRegular'].DisplayLabel = (i) => {return (i.weekWorkDaysRegular)};
            state.headerMap['monthTimeRegular'].sort = false;
            state.headerMap['monthTimeRegular'].align = 'center';
            state.headerMap['monthTimeRegular'].label = this.$t('store.allowedContracts.monthAverage');
            state.headerMap['monthTimeRegular'].DisplayLabel = (i) => {return (i.monthTimeRegular/60).toFixed(2)};
            state.headerMap['additionalMonthWorkTime'].sort = false;
            state.headerMap['additionalMonthWorkTime'].align = 'center';
            state.headerMap['additionalMonthWorkTime'].label = this.$t('pages.employeeContract.additionalMonthWorkTime');
            state.headerMap['additionalMonthWorkTime'].DisplayLabel = (i) => {return (i.additionalMonthWorkTime/60).toFixed(2)};
            state.headerMap['workTimeFactor'].sort = false;
            state.headerMap['workTimeFactor'].align = 'center';
            state.headerMap['workTimeFactor'].label = this.$t('store.allowedContracts.averageFactor');
            state.headerMap['workTimeFactor'].DisplayLabel = (i) => {return (i.workTimeFactor/Math.pow(10,7)).toFixed(4)};
            state.headerMap['overtime'].sort = false;
            state.headerMap['overtime'].align = 'center';
            state.headerMap['overtime'].label = this.$t('store.allowedContracts.overtimeFrom');
            state.headerMap['overtime'].DisplayLabel = (i) => {return view.collectiveContractMap[i.collectiveContractId] ? (view.collectiveContractMap[i.collectiveContractId].weeklyOvertimeCutoff/60).toFixed(2)+'h / '+ (view.collectiveContractMap[i.collectiveContractId].overtimeCutoff/60).toFixed(2)+'h': ""};
            state.headerMap['active'].sort = false;
            state.headerMap['active'].align = 'center';
            state.headerMap['active'].label = this.$t('global.general.active');
            state.headerMap.active.componentTypeRow = 'checkbox';
            state.headerMap.active.componentStateBuilder = (item) => {
                return {
                    propContainer: {value: item.active, data: item},
                    customEvents: {
                        Update: ($event, value, item) => {
                            item.active = value;
                            view.updateAllowedContract(item);
                        }
                    }
                };
            };



            state.headerMap['actions'] = {align: 'center',
                buttons:[
                    {icon: 'fas fa-edit', action: ($event, data) => view.EditAllowedContract($event, data)},
                    {icon: 'fas fa-trash', action: ($event, data) => view.DeleteAllowedContractModal($event, data)},
                ]
            };
            state.headerMap['actions'].width = '100px';
            return state;
        },
        headerButtons(){

            let view = this;

            let state= {
                buttons: []
            };
            //BUTTON 1




            state.buttons.push({
                type: "block",
                icon: "fa-sync-alt",
                click: () => {
                    view.refresh(true);
                },
                tooltip: this.$t('global.general.refreshData')
            });
            state.buttons.push({type: "block green", icon: "fa-plus",click: ($event) => {view.AddAllowedContract($event)},
                tooltip: (this.storeSettings.country == 1 ? this.$t('pages.employeeContract.collectiveContract') : this.$t('pages.employeeContract.contractModel')) +' ' + this.$t('global.ui.add').toLowerCase(),
                title: (this.storeSettings.country == 1 ? this.$t('pages.employeeContract.collectiveContract') : this.$t('pages.employeeContract.contractModel')) +' ' + this.$t('global.ui.add').toLowerCase(),
                helperText: this.$t('store.allowedContracts.contractsHelp1')+(this.storeSettings.country == 1 ? this.$t('store.allowedContracts.collectiveContracts') : this.$t('store.allowedContracts.allowedContracts')) +this.$t('store.allowedContracts.contractsHelp2')});
            state.helperLinks = [
                {
                    icon: "fa-video",
                    title: this.$t('store.structure.watchTrainingVideo'),
                    helperText: this.$t('store.structure.watchTrainingVideoHelp'),
                    externalUrl: "https://www.youtube.com/watch_popup?v=ES15Y5i5vKU",
                    externalLabel: this.$t('store.structure.watchTrainingVideoLabel'),
                    cancelLabel: this.$t('global.ui.close'),
                },
                {
                    title:  this.$t('store.structure.getSupport'),
                    helperText:  this.$t('store.structure.getSupportHelp'),
                    externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/16",
                    externalLabel:  this.$t('store.structure.getSupportLabel'),
                    cancelLabel: this.$t('global.ui.close'),
                }
            ];
            return state;
        },
    },
    watch: {

        storeId: function(val, oldVal) {
            this.refresh();
        },
    },
    // methods that implement data logic.
    methods: {
        refresh: function(){
            let view = this;

            view.$helpers.GetCollectiveContractMap()
                .then(response => {
                    return view.loadAllowedContracts();
                }).then(response => {
                view.updateAllowedContracts(response.data);
            }).catch(function (error) {
                console.log(error);
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
            })

        },
        AddAllowedContract($event){
            let view = this;

            let maxF = 4.3333;
            if(this.storeSettings.country == 2){
                maxF = 4.5;
            }

            let ccitems = Object.values(view.collectiveContractMap)
                .filter(i=> i.country == this.storeSettings.country)
                .map(i => {return {label: i.name, value: i.id, data: i}});
            ccitems.sort((a,b) => {
                return (a.label == "Systemgastronomie")? -1 : (b.label == "Systemgastronomie")? 1 : (a.label > b.label)? -1 : (b.label > a.label)? 1 : 0;
            });
            let first = ccitems.length > 0 ? ccitems[0] : null;
            let overtime = '';
            if(first != null){
                let collectiveContractId = first.value;
                if(collectiveContractId){
                    overtime = view.collectiveContractMap[collectiveContractId] ? (view.collectiveContractMap[collectiveContractId].weeklyOvertimeCutoff/60).toFixed(2)+'h / '+ (view.collectiveContractMap[collectiveContractId].overtimeCutoff/60).toFixed(2)+'h': ""
                }
            }

            view.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [

                        {label: (this.storeSettings.country == 1 ? this.$t('pages.employeeContract.collectiveContract') : this.$t('pages.employeeContract.contractModel')), key: 'collectiveContractId', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, dropdownSearchState:{
                                toggled: false,
                                displayedItems: [],
                                input: '',
                                items: ccitems,
                                selectMultiple: false,
                                selectedItems: [],
                                selectFirst: true,
                                styleLight: true,
                            }},
                        {label: this.$t('pages.employeeContract.weekTimeRegular'), key: 'weekTimeRegular', hidden: false, type: 'slider', value: 40*60, min: 0*60,
                            max: 60*60, slider: {hideMin: true, hideMax: true, min: 0*60, max: 60*60, value: 40*60, step: 1,
                                DisplayLabel: (val) => {
                                    let hours = this.$helpers.pad2(Math.floor(val / 60));
                                    let minutes = this.$helpers.pad2(val % 60);
                                    return hours + ':' + minutes+"/"+(val/60).toFixed(2)+"h";
                                }, inputControl: true, sliderInput: (x) => {return x * 60}, labelToInt: (x) => {return x.slice(0, -1)},
                                shorterDisplayLabel: (x) => {return (x / 60.0).toFixed(2)+'h'}},
                            computed: (datafill, lastVal, entryBeforeUpdate) => {
                                let collectiveContractId = datafill.entries.find(i => i.key == 'collectiveContractId').value;

                                if(collectiveContractId){
                                    let contract = view.collectiveContractMap[collectiveContractId]
                                    entryBeforeUpdate.slider.max = contract.weekTimeMax;
                                    if(entryBeforeUpdate.slider.value > entryBeforeUpdate.slider.max){
                                        entryBeforeUpdate.slider.value = entryBeforeUpdate.slider.max;
                                        entryBeforeUpdate.value = entryBeforeUpdate.slider.value;
                                    }

                                    entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);

                                }
                                return entryBeforeUpdate;
                            }
                        },
                        {label: this.$t('store.settings.workingDays'), key: 'weekWorkDaysRegular', hidden: false, type: 'slider', value: 5, min: 1,
                            max: 7, slider: {hideMin: true, hideMax: true, min: 1, max: 7, value: 5, step: 1, inputControl: true,
                                sliderInput: (x) => {return x}}},
                        {label: this.$t('pages.employeeContract.additionalMonthWorkTime'), key: 'additionalMonthWorkTime', hidden: false, type: 'slider',
                            value: 0*60, min: 0*60, max: 60*60, slider: {hideMin: true, hideMax: true, min: 0*60, max: 60*60,
                                value: 0*60, step: 3, DisplayLabel: (val) => {
                                    let hours = this.$helpers.pad2(Math.floor(val / 60));
                                    let minutes = this.$helpers.pad2(val % 60);
                                    return hours + ':' + minutes+"/"+(val/60).toFixed(2)+"h";
                                }, inputControl: true, sliderInput: (x) => {return x * 60}, labelToInt: (x) => {return x.slice(0, -1)},
                                shorterDisplayLabel: (x) => {return (x / 60.0).toFixed(2)+'h'}}},


                        {label: this.$t('store.allowedContracts.averageFactor'), key: 'workTimeFactor', hidden: false, type: 'slider',
                            value: this.storeSettings.workTimeFactor, min: 4 * Math.pow(10, 7), max: maxF * Math.pow(10, 7),
                            slider: {
                                hideMin: true, hideMax: true, min: 4 * Math.pow(10, 7), max: maxF * Math.pow(10, 7),
                                value: this.storeSettings.workTimeFactor, step: 0.0001 * Math.pow(10, 7),
                                DisplayLabel: (x) => {
                                    return (x / Math.pow(10, 7)).toFixed(4);
                                }, inputControl: true, sliderInput: (x) => {return x * Math.pow(10, 7)},
                            },
                            computed: (datafill, lastVal, entryBeforeUpdate) => {
                                let invertFactor = datafill.entries.find(i => i.key == 'invertFactor').value;

                                if(invertFactor){
                                    let weekTimeRegular = datafill.entries.find(i => i.key == 'weekTimeRegular').value;
                                    let monthTimeRegular = parseFloat(datafill.entries.find(i => i.key == 'monthTimeRegular').value);
                                    let calcFactor = (monthTimeRegular*60) / weekTimeRegular;
                                    if(calcFactor < 4.0){
                                        calcFactor = 4.0;
                                    } else if(calcFactor > maxF){
                                        calcFactor = maxF;
                                    }
                                    calcFactor = Math.round(calcFactor*Math.pow(10,7));
                                    entryBeforeUpdate.value = calcFactor;
                                    entryBeforeUpdate.slider.value = calcFactor;
                                    entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                                    entryBeforeUpdate.disabled = true;
                                    entryBeforeUpdate.slider.disabled = true;
                                } else {
                                    entryBeforeUpdate.disabled = false;
                                    entryBeforeUpdate.slider.disabled = false;
                                }
                                return entryBeforeUpdate;
                            }
                        },

                        {label: this.$t('store.allowedContracts.monthAverage'), key: 'monthTimeRegular', hidden: false, type: 'output', disabled: true, value: (Math.round(40*60*(this.storeSettings.workTimeFactor/Math.pow(10,7)))/60).toFixed(2), computed: (datafill, lastVal, entryBeforeUpdate) => {
                                let weekTimeRegular = datafill.entries.find(i => i.key == 'weekTimeRegular').value;
                                let invertFactor = datafill.entries.find(i => i.key == 'invertFactor').value;
                                if(invertFactor){
                                    entryBeforeUpdate.disabled = false;
                                    entryBeforeUpdate.type = 'text'
                                    let calcFactor = (parseFloat(entryBeforeUpdate.value)*60)/weekTimeRegular;

                                    if(calcFactor < 4.0){
                                        entryBeforeUpdate.value = (Math.round(weekTimeRegular *4.0)/60).toFixed(2)
                                    }
                                    if(calcFactor > maxF){
                                        entryBeforeUpdate.value = (Math.round(weekTimeRegular *maxF)/60).toFixed(2)
                                    }
                                } else {
                                    entryBeforeUpdate.disabled = true;
                                    entryBeforeUpdate.type = 'output';
                                    let factor = datafill.entries.find(i => i.key == 'workTimeFactor').value;
                                    entryBeforeUpdate.value = (Math.round(weekTimeRegular*(factor/Math.pow(10,7)))/60).toFixed(2);
                                }

                                return entryBeforeUpdate;
                            }},
                        {label: this.$t('global.ui.edit'), key: 'invertFactor', hidden: false, type: 'bool', value: false},
                        {label: this.$t('store.allowedContracts.overtimeFrom'), key: 'overtime', hidden: false, type: 'output', disabled: true, value: overtime, computed: (datafill, lastVal, entryBeforeUpdate) => {
                                let collectiveContractId = datafill.entries.find(i => i.key == 'collectiveContractId').value;
                                if(collectiveContractId){
                                    entryBeforeUpdate.value = view.collectiveContractMap[collectiveContractId] ? (view.collectiveContractMap[collectiveContractId].weeklyOvertimeCutoff/60).toFixed(2)+'h / '+ (view.collectiveContractMap[collectiveContractId].overtimeCutoff/60).toFixed(2)+'h': ""
                                } else {
                                    entryBeforeUpdate.value = '';
                                }

                                return entryBeforeUpdate;
                            }}



                    ],
                    selectCallback: function (item) {
                        view.createAllowedContract(item);
                    }
                },
                header: (this.storeSettings.country == 1 ? this.$t('pages.employeeContract.collectiveContract') : this.$t('pages.employeeContract.contractModel')) +' ' + this.$t('global.ui.add').toLowerCase(),
                width: "600px",
                expanded: true,
                centered: true
            });
        },
        createAllowedContract: function(item){
            let view = this;
            let url = '/api/sec/allowedcontract';

            let params = {
                storeId: this.$store.state.storeId,
            };

            let payload = {
                collectiveContractId: item.collectiveContractId,
                weekTimeRegular: item.weekTimeRegular,
                weekWorkDaysRegular: item.weekWorkDaysRegular,
                workTimeFactor: item.workTimeFactor,
                additionalMonthWorkTime: item.additionalMonthWorkTime,
                monthTimeRegular: Math.round(item.weekTimeRegular*(item.workTimeFactor/Math.pow(10,7)))
            }

            if(Object.values(view.allowedContractMap).filter(i => i.collectiveContractId == payload.collectiveContractId
                && i.weekTimeRegular == payload.weekTimeRegular
                && i.weekWorkDaysRegular == payload.weekWorkDaysRegular
                && i.additionalMonthWorkTime == payload.additionalMonthWorkTime).length > 0){
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.allowedContracts.modelAlreadyExists'));
            } else {
                this.axios({
                    method: 'post',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    view.$set(view.allowedContractMap, ''+response.data.data.id, response.data.data);
                    view.$store.commit("invalidateState", {states: ["employeeTypeTemplateMapState", "employeeTypeMapState", "allowedContractMapState"]});
                    view.$helpers.success(view.$t('global.notifications.success'), (view.storeSettings.country == 1 ? this.$t('pages.employeeContract.collectiveContract') : this.$t('pages.employeeContract.contractModel')) +' wurde erfolgreich hinzugefügt');
                }).catch(function (error) {

                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('workBalance.accounting.addedError'));
                })
            }



        },
        EditAllowedContract($event, contract){
            let view = this;
            let maxF = 4.3333;
            if(this.storeSettings.country == 2){
                maxF = 4.5;
            }

            view.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [
                        {label: 'Id', key: 'id', hidden: true, type: '', value: contract.id},
                        {label: this.$t('global.general.active'), key: 'active', hidden: true, type: 'bool', value: contract.active},
                        {label: this.$t('store.allowedContracts.averageFactor'), key: 'workTimeFactor', hidden: false, type: 'slider',
                            value: contract.workTimeFactor, min: 4*Math.pow(10,7), max: maxF*Math.pow(10,7), slider: {
                                hideMin: true, hideMax: true, min: 4*Math.pow(10,7), max: maxF*Math.pow(10,7),
                                value: contract.workTimeFactor, step: 0.0001 *Math.pow(10,7),
                                DisplayLabel: (x) => {return (x/Math.pow(10,7)).toFixed(4)},
                                inputControl: true, sliderInput: (x) => {return x * Math.pow(10,7)}},
                            computed: (datafill, lastVal, entryBeforeUpdate) => {
                                let invertFactor = datafill.entries.find(i => i.key == 'invertFactor').value;

                                if(invertFactor){
                                    let weekTimeRegular = contract.weekTimeRegular;
                                    let monthTimeRegular = parseFloat(datafill.entries.find(i => i.key == 'monthTimeRegular').value);
                                    let calcFactor = (monthTimeRegular*60) / weekTimeRegular;
                                    if(calcFactor < 4.0){
                                        calcFactor = 4.0;
                                    } else if(calcFactor > maxF){
                                        calcFactor = maxF;
                                    }
                                    calcFactor = Math.round(calcFactor*Math.pow(10,7));
                                    entryBeforeUpdate.value = calcFactor;
                                    entryBeforeUpdate.slider.value = calcFactor;
                                    entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                                    entryBeforeUpdate.disabled = true;
                                    entryBeforeUpdate.slider.disabled = true;
                                } else {
                                    entryBeforeUpdate.disabled = false;
                                    entryBeforeUpdate.slider.disabled = false;
                                }
                                return entryBeforeUpdate;
                            }
                        },

                        {label: this.$t('store.allowedContracts.monthAverage'), key: 'monthTimeRegular', hidden: false, type: 'output', disabled: true, value: (Math.round(contract.weekTimeRegular*(contract.workTimeFactor/Math.pow(10,7)))/60).toFixed(2), computed: (datafill, lastVal, entryBeforeUpdate) => {
                                let weekTimeRegular = contract.weekTimeRegular;
                                let invertFactor = datafill.entries.find(i => i.key == 'invertFactor').value;
                                if(invertFactor){
                                    entryBeforeUpdate.disabled = false;
                                    entryBeforeUpdate.type = 'text'
                                    let calcFactor = (parseFloat(entryBeforeUpdate.value)*60)/weekTimeRegular;

                                    if(calcFactor < 4.0){
                                        entryBeforeUpdate.value = (Math.round(weekTimeRegular *4.0)/60).toFixed(2)
                                    }
                                    if(calcFactor > maxF){
                                        entryBeforeUpdate.value = (Math.round(weekTimeRegular * maxF)/60).toFixed(2)
                                    }
                                } else {
                                    entryBeforeUpdate.disabled = true;
                                    entryBeforeUpdate.type = 'output';
                                    let factor = datafill.entries.find(i => i.key == 'workTimeFactor').value;
                                    entryBeforeUpdate.value = (Math.round(weekTimeRegular*(factor/Math.pow(10,7)))/60).toFixed(2);
                                }

                                return entryBeforeUpdate;
                            }},
                        {label: this.$t('global.ui.edit'), key: 'invertFactor', hidden: false, type: 'bool', value: false},

                    ],
                    width: "500px",
                    selectCallback: function(item) {
                        view.updateAllowedContract(item);
                    }
                },
                header: (this.storeSettings.country == 1 ? this.$t('pages.employeeContract.collectiveContract') : this.$t('pages.employeeContract.contractModel')) + ' bearbeiten',
                expanded: true,
                centered: true
            });
        },
        updateAllowedContract(item) {
            let view = this;
            let url = '/api/sec/allowedcontract';

            let params = {
                storeId: this.$store.state.storeId,
            };
            let ac = view.allowedContractMap[item.id];
            let payload = {
                id: item.id,
                workTimeFactor: item.workTimeFactor,
                monthTimeRegular: Math.round(ac.weekTimeRegular * (item.workTimeFactor / Math.pow(10, 7))),
                active: item.active,
                updateFields: ["workTimeFactor", "monthTimeRegular", "active"]
            }

            this.axios({
                method: 'put',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {

                ac.workTimeFactor = item.workTimeFactor;
                ac.monthTimeRegular = payload.monthTimeRegular;

                view.$set(view.allowedContractMap, '' + ac.id, ac);
                view.$store.commit("invalidateState", { states: ["employeeTypeTemplateMapState", "employeeTypeMapState", "allowedContractMapState"] });
                view.$helpers.success(view.$t('global.notifications.success'), (view.storeSettings.country == 1 ? this.$t('pages.employeeContract.collectiveContract') : this.$t('pages.employeeContract.contractModel')) + ' wurde erfolgreich aktualisiert');
            }).catch(function(error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('workBalance.payroll.editError'));
            })
        },
        DeleteAllowedContractModal($event, data) {
            let view = this;
            view.$helpers.OpenAlert({
                header: (this.storeSettings.country == 1 ? this.$t('pages.employeeContract.collectiveContract') : this.$t('pages.employeeContract.contractModel')) + ' löschen',
                description: 'Sind Sie sicher dass Sie den Eintrag löschen wollen?',
                callbackAccept: (alert) => {
                    alert.hidden = true;
                    view.deleteAllowedContract(data);
                }
            });
        },
        deleteAllowedContract: function(data) {

            let view = this;
            let url = '/api/sec/allowedcontract';

            let params = {
                storeId: this.$store.state.storeId,
                id: data.id
            };


            this.axios({
                method: 'delete',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            }).then(response => {
                view.$delete(view.allowedContractMap, '' + data.id);
                view.$store.commit("invalidateState", { states: ["employeeTypeTemplateMapState", "employeeTypeMapState", "allowedContractMapState"] });
                view.$helpers.success(view.$t('global.notifications.success'), (view.storeSettings.country == 1 ? this.$t('pages.employeeContract.collectiveContract') : this.$t('pages.employeeContract.contractModel')) + ' wurde erfolgreich gelöscht');
            }).catch(function(error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.deleteFailed'));
            })

        },

        loadAllowedContracts: function() {

            let url = '/api/sec/allowedcontract';
            let params = {
                storeId: this.$store.state.storeId,
            };

            return this.axios({
                method: 'get',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            })


        },
        updateAllowedContracts: function(data) {
            let allowedContractMap = {};
            for (let i = 0; i < data.length; i++) {
                allowedContractMap[data[i].id] = data[i];
            }
            this.allowedContractMap = allowedContractMap;
        },

    },

}
</script>


<style scoped>
.tablecontainer {
    padding-left: 30px;
    padding-right: 30px;
}

.has-header > .has-header > .scrollbar-container {
    height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
    top: var(--header-height);
}

.header.top {
    margin: 10px 0;
}

.data-table {
    top: 10px;
    position: relative;
}

.loading {

    -webkit-filter: none !important;
    filter: none !important;
    position: absolute;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    bottom: 0;
    left: 0;
    top: initial;
    width: 100%;
    height: calc(100vh - 109px);
    background: rgba(0, 0, 0, .5);
    z-index: 10;
    position: fixed;
}

.header > .header.date {
    width: fit-content;
}

.paging {
    top: 0;
    bottom: 0;
    right: 250px;
}

.header > .text-filter {
    top: 0;
    bottom: 0;
    width: 230px;
    right: 45px;
}

</style>
